// extracted by mini-css-extract-plugin
export default {"title_container":"index-module--title_container--BFR8m","title":"index-module--title--c3Y6B","childContainer":"index-module--childContainer--VvdWV"};